import { BgImageContainer } from '@components/Layouts/BgImageContainer';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { ConfirmationSection } from '@components/TireOffer/ConfirmationSection';
import { useTireQuoteSlug } from '../../../hooks/useTireQuoteSlug';

export const InvoicedOrderConfirmed = () => {
  const slug = useTireQuoteSlug();
  return (
    <BgImageContainer>
      <ContentWrapperCustomerApp hideBackButton className='flex min-h-[60vh] items-center justify-center'>
        <ConfirmationSection invoicedPayment slug={slug} />
      </ContentWrapperCustomerApp>
    </BgImageContainer>
  );
};
